import { SortItem } from './member.dashboard.license.response';

export class GlobalPhoneWhitelistBasic {
    ID: number;
    DateTimeCreated: Date;
    Phone: string;

    public static FixDates(item: GlobalPhoneWhitelistBasic) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class GlobalPhoneWhitelistBasicArray extends Array<GlobalPhoneWhitelistBasic> {
    public LastSort: SortItem;

    constructor(...items: GlobalPhoneWhitelistBasic[]) {
        super(...items);
        Object.setPrototypeOf(this, GlobalPhoneWhitelistBasicArray.prototype);
    }

    public static FixDates(item: GlobalPhoneWhitelistBasicArray) {
        item.forEach(x => GlobalPhoneWhitelistBasic.FixDates(x));
    }

}
